import * as Common from '@/tenant/common';

export class SKU extends Common.MasterBase{
  constructor(){
    super('SKU');
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public id: number = 0;
  public commodityId: number = 0;
  public commodity: Common.Commodity = null;
  public code: string = '';
  public name: string = '';
  public model: string = '';
  public barcodeType: number = 0;
  public barcode: string = '';
  public minimumStockQuantity: number = 0;
  public replenishmentQuantity: number = 0;
  public replenishmentUomCode: string = null;
  public replenishmentUom: Common.Conversion = null; // クライアント側表示用荷姿

  public set replenishmentUom2(conv : Common.Conversion){
    this.replenishmentUom = conv;
    if(conv == null || conv.code == null) this.replenishmentUomCode = null;
    else this.replenishmentUomCode = conv.code;
  }
  public get replenishmentUom2(): Common.Conversion{
    if(this.replenishmentUom == null && this.commodity!=null) return this.commodity.getDefaultConversion();
    return this.replenishmentUom;
  }
  public ecFlag: Common.ECFlags = Common.ECFlags.None;
  public get ecFlag2() { return this.ecFlag;}
  public set ecFlag2(value: Common.ECFlags) {this.ecFlag = value; this.ecBaseId = null;}
  public ecBaseId:string = null;
  
  public copy():any {
    const temp = super.copy() as SKU;
    temp.id = 0;
    temp.code = null;
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    return temp;
  }
}

export enum BarcodeTypes {
  None = 0,
  JAN13 = 1,
  JAN8 = 2,
  UPCA = 3,
  UPCE = 4,
  ITF14 = 5,
  Codabar = 6,
  Code39 = 7,
  Code128 = 8,
}

export class SKUQuery extends Common.LoadQuery {
  constructor(){
    super('SKUQuery',SKU);
    this.sort = 'code';
  }
  public commodityCode: string = '';
  public commodityName: string = '';
  public commodity: Common.Commodity = null;
  public code: string = '';
  public name: string = '';
  public barcode: string = '';
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string = '';
}

export class SKUMasterQuery extends Common.LoadQuery {
  constructor(){
    super('SKUMasterQuery',SKU);
  }
  public commodityId: number = 0;
}